export const APP_CONFIG = {
  debug: true,
  apiUrl: process.env.API_URL,
  imgUrl: process.env.IMAGE_URL,
  profileKey: process.env.USER_PROFILE_KEY,
  tokenKey: process.env.TOKEN_KEY,
};
